export default __webpack_public_path__ + "static/media/do-include-walks.40e35851.svg";